<template>
  <div id="points-index">
    <!-- product-modal -->
    <div class="popup" :class="isProductPopup ? 'active' : ''">
      <div class="popup-wrapper" :style="isProductPopup ? 'bottom:0' : 'bottom:-680px'">
        <div class="times-icon" @click="closePop"><img src="@/assets/img/times.png" alt=""></div>
        <div class="popup-content">
          <div class="img">
            <img :src="product.img || '@/assets/img/test.png'" alt="">
          </div>
          <div class="info">
            <p class="font-20 bold">{{ product.title }}</p>
            <div class="detailed">
              <p class="point"><img src="@/assets/img/point.png" alt="">{{ product.point }}點</p>
              <p class="font-15">兌換日期：{{ product.start_redeem }} ~ {{ product.end_redeem }}</p>
            </div>
          </div>
        </div>
        <p class="popup-border"></p>
        <ud-input v-if="product.type === 'mmem'" type="number" v-model="phone" placeholder="輸入手機號碼" disabled />
        <p class="phone-tips" v-if="product.type === 'mmem'">僅能兌換與星裕會員相同手機號碼之摩曼頓帳號</p>
        <div class="form verify" v-show="product.type === 'mmem'">
          <ud-input class="form-control form-control-lg" type="text" id="verify" v-model="verify" placeholder="驗證碼" />
          <div id="random">
            <canvas id="verifyCanvas" width="126" height="48"></canvas><img id="code_img" />
            <input id="varifyhidden" type="hidden" />
          </div>
          <div class="refresh">
            <img id="refresh" src="@/assets/img/reset.png" alt="" />
          </div>
        </div>
        <div class="popup-buy">
          <div class="popup-quantity">
            <p class="bold">購買組數</p>
            <p class="font-12">剩餘組數{{ product.inventory }}組</p>
          </div>
          <div class="popup-count">
            <button class="reduce" @click="reduceQuantity"><span>-</span></button>
            <span class="quantity">{{ quantity }}</span>
            <button class="add" @click="addQuantity"><span>+</span></button>
          </div>
        </div>
        <button class="exchange_button" @click="submit(phone)"><img src="@/assets/img/exchange_button.png"
            alt=""></button>
      </div>
    </div>

    <!-- exchange-modal -->
    <div class="exchange-popup" v-if="isExchangePopup">
      <div class="exchange-popup-wrapper">
        <div class="exchange-content">
          <h2>確認使用會員點數進行兌換?</h2>
          <div class="exchange-info">
            <p>使用點數：{{ quantity * product.point }}點</p>
            <p>兌換商品：{{ product.title }}</p>
            <p>兌換組數：{{ quantity }}</p>
            <p v-show="product.type === 'mmem'">兌換之手機號碼：{{ phone }}</p>
          </div>
          <div class="exchange-button">
            <button class="close_button" @click="isExchangePopup = false"><img src="@/assets/img/close_button.png"
                alt=""></button>
            <button class="confirm_button" @click="checkOut()"><img src="@/assets/img/confirm_button.png"
                alt=""></button>
          </div>
          <p class="precautions">提醒您，點選【確認兌換】後，<br>將即時扣除點數，無法取消或返還。</p>
        </div>
      </div>
    </div>

    <!-- remind-modal -->
    <div class="remind-popup" v-if="isRemindPopup">
      <div class="remind-popup-wrapper">
        <div class="remind-content">
          <h2>{{ remindTitle }}</h2>
          <p>{{ remindText }}</p>
          <button class="remind-button" @click="closeRemind()"><img src="@/assets/img/remind_button.png"
              alt=""></button>
        </div>
      </div>
    </div>

    <header><img src="@/assets/img/logo.png" alt=""></header>
    <div class="container">
      <div class="wrapper">

        <div class="nav-area">
          <div class="nav-return" @click="toUrl('points')">
            <img src="@/assets/img/return_page.png" alt="">
          </div>
          <div class="nav-title">
            <img src="@/assets/img/points_title.png" alt="">
          </div>
        </div>

        <div class="product">
          <div class="product-img">
            <img :src="product.img || '@/assets/img/test.png'" alt="">
          </div>
          <div class="product-info">
            <p class="product-point"><img src="@/assets/img/point.png" alt="">{{ product.point }}點</p>
            <p class="font-20 bold">{{ product.title }}</p>
            <p class="color-c font-18">{{ product.description }}</p>
            <div class="product-text">
              <p>兌換日期：{{ product.start_redeem }} ~ {{ product.end_redeem }}</p>
              <p>剩餘組數{{ product.inventory }}組</p>
            </div>
            <div class="precautions">
              <p class="precautions-title font-18">注意事項：</p>
              <p class="precautions-text" v-html="product.note"></p>
            </div>
          </div>
          <button class="exchange_button" @click="showPop"><img src="@/assets/img/exchange_button.png" alt=""></button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/utils/Api';

export default {
  name: 'pointsInfo',
  data() {
    return {
      canCheckout: true,
      isProductPopup: false,
      isExchangePopup: false,
      isRemindPopup: false,
      product: {},
      quantity: 0,
      phone: '',
      remindTitle: '',
      remindText: '',
      verify: ''
    }
  },
  mounted() {
    document.body.style.background = '#060606';
    let productSeq = this.$route.query.seq;
    this.initial(productSeq);

    //隨機圖片驗證碼
    var nums = "123456789".split(
      ""
    );
    drawCode();
    // 绘制验证码
    function drawCode() {
      var canvas = document.getElementById("verifyCanvas"); //获取HTML端画布
      var context = canvas.getContext("2d"); //获取画布2D上下文
      context.fillStyle = "#fff"; //画布填充色
      context.fillRect(0, 0, canvas.width, canvas.height); //清空画布
      context.fillStyle = "#000"; //设置字体颜色
      context.font = "25px Arial"; //设置字体
      var rand = new Array();
      var x = new Array();
      var y = new Array();
      for (var i = 0; i < 4; i++) {
        rand[i] = nums[Math.floor(Math.random() * nums.length)];
        x[i] = i * 16 + 10;
        y[i] = Math.random() * 20 + 20;
        context.fillText(rand[i], x[i], y[i]);
      }
      var test = rand.join("");
      window.jQuery("#varifyhidden").val(test);
      //画3条随机线
      for (var i = 0; i < 3; i++) {
        drawline(canvas, context);
      }
      // 画30个随机点
      for (var i = 0; i < 30; i++) {
        drawDot(canvas, context);
      }
      convertCanvasToImage(canvas);
    }
    // 随机线
    function drawline(canvas, context) {
      context.moveTo(
        Math.floor(Math.random() * canvas.width),
        Math.floor(Math.random() * canvas.height)
      ); //随机线的起点x坐标是画布x坐标0位置，y坐标是画布高度的随机数
      context.lineTo(
        Math.floor(Math.random() * canvas.width),
        Math.floor(Math.random() * canvas.height)
      ); //随机线的终点x坐标是画布宽度，y坐标是画布高度的随机数
      context.lineWidth = 0.5; //随机线宽
      context.strokeStyle = "rgba(100,100,100,1)"; //随机线描边属性
      context.stroke(); //描边，即起点描到终点
    }
    // 随机点(所谓画点其实就是画1px像素的线，方法不再赘述)
    function drawDot(canvas, context) {
      var px = Math.floor(Math.random() * canvas.width);
      var py = Math.floor(Math.random() * canvas.height);
      context.moveTo(px, py);
      context.lineTo(px + 1, py + 1);
      context.lineWidth = 0.2;
      context.stroke();
    }
    // 绘制图片
    function convertCanvasToImage(canvas) {
      document.getElementById("verifyCanvas").style.display = "none";
      var image = document.getElementById("code_img");
      image.src = canvas.toDataURL("image/png");
      return image;
    }
    // 点击图片刷新
    document.getElementById("code_img").onclick = function () {
      window.jQuery("#verifyCanvas").remove();
      window
        .jQuery("#verify")
        .after('<canvas width="126" height="48" id="verifyCanvas"></canvas>');
      drawCode();
    };
    document.getElementById("refresh").onclick = function () {
      window.jQuery("#verifyCanvas").remove();
      window
        .jQuery("#verify")
        .after('<canvas width="126" height="48" id="verifyCanvas"></canvas>');
      drawCode();
    };
    window.jQuery("#select").on("change", function () {
      if (window.jQuery(this).val() !== "1") {
        window.jQuery(this).addClass("sec2").removeClass("sec1");
      } else {
        window.jQuery(this).addClass("sec1").removeClass("sec2");
      }
    });
  },
  computed: {

  },
  methods: {
    async initial(seq) {
      let accessToken = this.$root.$data.accessToken;
      let api = new Api(accessToken, accessToken);
      let { data: { data } } = await api.getProductsInfo(seq);
      this.product = data;

      if(this.product.type === "mmem"){
        this.getUserInfo();
      }
    },
    addQuantity() {
      this.quantity += 1;
    },
    reduceQuantity() {
      if (this.quantity > 0) {
        this.quantity -= 1;
      }
    },
    submit(phone) {
      const errors = [];
      const regex = /^09\d{8}$/;

      if (this.phone === "" && this.product.type === "mmem") {
        errors.push('手機號碼必須填寫');
        this.remindTitle = '錯誤訊息'
        this.remindText = errors.join("<br />")
        this.isRemindPopup = true;
        return false;
        
      } else if (!regex.test(phone) && this.product.type === "mmem") {
        errors.push('手機號碼格式有誤');
        this.remindTitle = '錯誤訊息'
        this.remindText = errors.join("<br />")
        this.isRemindPopup = true;
        return false;
      }

      // 檢查驗證碼
      const verifyCode = document.getElementById("varifyhidden").value;

      if (this.verify === "" && this.product.type === "mmem"){
        errors.push('驗證碼必須填寫');
        this.remindTitle = '錯誤訊息'
        this.remindText = errors.join("<br />")
        this.isRemindPopup = true;
        return false;

      }else if (this.verify !== verifyCode && this.product.type === "mmem") {
        errors.push('驗證碼輸入錯誤');
        this.remindTitle = '錯誤訊息'
        this.remindText = errors.join("<br />")
        this.isRemindPopup = true;
        return false;

      }else if (this.quantity === 0) {
        errors.push('購買組數不可為0');
        this.remindTitle = '錯誤訊息'
        this.remindText = errors.join("<br />")
        this.isRemindPopup = true;
        return false;
      }
      this.checkInventory();
      return true;
    },
    async checkInventory() {
      let accessToken = this.$root.$data.accessToken;
      let api = new Api(accessToken, accessToken);

      let resultObj = {
        seq: this.product.seq,
        phone: this.phone,
        qty: this.quantity,
        type: this.product.type,
      };

      await api.getCheckInventory(resultObj)
        .then(response => {
          this.isExchangePopup = true;
        }).catch(error => {
          let errorMessage = "未知錯誤";
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          this.remindTitle = '錯誤訊息';
          this.remindText = errorMessage;
          this.isRemindPopup = true;
        });

    },
    async checkOut() {
      if (!this.canCheckout) return;
      this.canCheckout = false;
      let accessToken = this.$root.$data.accessToken;
      let api = new Api(accessToken, accessToken);

      let resultObj = {
        seq: this.product.seq,
        phone: this.phone,
        qty: this.quantity,
        type: this.product.type,
      };

      await api.getCheckout(resultObj)
        .then(response => {
          this.remindTitle = '提醒'
          this.remindText = '兌換成功'
          this.isRemindPopup = true;
          this.isExchangePopup = false;
          this.closePop();
        }).catch(error => {
          let errorMessage = "未知錯誤";
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          this.remindTitle = '錯誤訊息';
          this.remindText = errorMessage;
          this.isRemindPopup = true;
        }).finally(() => {
          this.canCheckout = true;
        })

    },
    async getUserInfo() {
      let accessToken = this.$root.$data.accessToken;
      let api = new Api(accessToken, accessToken);

      let { data: { data } } = await api.getUserInfo();
      this.phone = data.phone;
    },
    closeRemind() {
      if (this.remindText === '兌換成功') {
        window.location.href = this.$lineFriend;
      } else {
        this.isRemindPopup = false;
      }
    },
    showPop() {
      this.isProductPopup = true;
    },
    closePop() {
      this.isProductPopup = false;
    },
    toUrl(val, params = {}) {
      this.$router.push({ path: `/${val}`, params: `/${params}` });
    },
  },
};
</script>

<style scoped>
.container {
  font-family: 'Roboto', sans-serif;
}

.bold {
  font-weight: bold;
}

.font-12 {
  font-size: 12px;
}

.font-15 {
  font-size: 15px;
}

.font-18 {
  font-size: 18px;
}

.font-20 {
  font-size: 20px;
}

.color-c {
  color: #fdf2c9;
}

p {
  margin: 0;
}

button {
  background: none;
  border: none;
}

button:focus {
  outline: none;
}

.status-color {
  color: var(--bronze);
}

header {
  position: relative;
}

/* nav */
.nav-area {
  display: flex;
  padding: 10px 0 30px 0;
  align-items: stretch;
  position: relative;
}

.nav-area .nav-return {
  position: absolute;
  left: 6.5%;
  width: 8.5%;
}

.nav-area .nav-title {
  width: 29%;
  margin: auto;
  margin-top: 3px;
}

/* product */
.product {
  text-align: justify;
  padding: 0px 25px;
  color: #fff;
}

.product-img {
  min-height: 330px;
}

.product-info .product-point {
  font-size: 25px;
  color: #eed061;
  font-weight: bold;
  padding: 15px 0 10px 0;
}

.product-info .product-point img {
  width: 16px;
  margin-right: 3px;
}

.product-info .product-text {
  padding: 15px 0;
}

.product-info .product-text p {
  font-size: 15px;
}

.product-info .precautions {
  line-height: 24px;
}

.product-info .precautions .precautions-text {
  font-size: 12px;
}

::v-deep .precautions-text p {
  font-size: 14px;
  margin: 0;
}

::v-deep .precautions-text ul li a {
  color: #fff
}

.product .exchange_button {
  display: block;
  margin: auto;
  width: 45%;
  padding: 20px 0 25px 0;
}

/* product-popup */
.popup {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
}

.active {
  opacity: 1;
  visibility: visible;
}

.popup-wrapper {
  position: absolute;
  left: 0;
  width: 100%;
  max-height: 680px;
  background: #8b8b8b;
  padding: 75px 10px 0 10px;
  transition: all 0.5s ease-in-out;
}

.popup-wrapper .times-icon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  right: 3%;
  top: 5%;
}

.popup-wrapper .times-icon img {
  height: 30px;
  width: 30px;
  display: block;
  margin: auto 0;
}

.popup-content {
  display: flex;
  color: #fff;
  gap: 10px;
  padding-bottom: 20px;
}

.popup-content .info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: start;
  width: 100%;
  line-height: 18px;
  font-size: 12px;
}

.popup-content .img {
  position: relative;
  width: 40%;
  min-height: 85px;
}

.popup-content .info .detailed {
  line-height: 22px;
}

.popup-content .point {
  font-size: 24px;
  color: #eed061;
  font-weight: bold;
}

.popup-content .point img {
  width: 20px;
  margin-right: 3px;
}

.popup-border {
  border-bottom: 2px solid #fdf2c9;
  margin-bottom: 55px;
}

.phone-tips {
  color: #fff;
  text-align: center;
  margin-top: 5px;
  font-size: 14px;
}

::v-deep.ud-input input {
  border-radius: 30px;
  text-align: center;
  font-size: 18px;
  background-color: #fff;
}

::v-deep.ud-input input:disabled{
  background-color: #d2d2d2;
  -webkit-test-fill-color: #fff;
  opacity: 1;
}

.popup-buy {
  display: flex;
  justify-content: space-between;
  color: #fff;
  padding-top: 20px;
}

.popup-buy .reduce {
  border: 1px solid #fff;
  color: #f0ca45;
  padding: 0px 11px 0px 11px;
}

.popup-buy .popup-count span {
  font-size: 27px;
  font-weight: bold;
}

.popup-buy .quantity {
  font-size: 30px;
  color: #f0ca45;
  padding: 0 10px;
  font-weight: bold;
}

.popup-buy .add {
  border: 1px solid #fff;
  color: #f0ca45;
  padding: 0px 9px 0px 9px;
}

.popup-wrapper .exchange_button {
  display: block;
  margin: auto;
  width: 32%;
  padding: 25px 0 40px 0;
}

/* exchange-modal */
.exchange-popup,
.remind-popup {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 999;
  opacity: 1;
  visibility: visible;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  overflow-x: hidden;
}

.exchange-popup-wrapper,
.remind-popup-wrapper {
  position: absolute;
  background: #fff;
  padding: 15px 25px 30px 25px;
  width: 95%;
  max-width: 400px;
  max-height: 88%;
  -webkit-box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.exchange-content h2 {
  color: #f0c948;
  font-size: 24px;
  text-align: justify;
  font-weight: bold;
  margin-bottom: 15px;
}

.exchange-content .exchange-info {
  text-align: left;
  font-weight: bold;
  color: #808080;
  line-height: 28px;
}

.exchange-content .exchange-info p {
  font-weight: bold;
  font-size: 17px;
}

.exchange-content .exchange-button {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}

.exchange-content .exchange-button img {
  width: 90%;
}

.exchange-content .exchange-button .confirm_button {
  text-align: right;
}

.exchange-content .exchange-button .close_button {
  text-align: left;
}

.exchange-content .precautions {
  color: #7f7f7f;
}

.form .input select {
  color: #ccc;
}

.form .input select {
  color: #ccc;
}

.form.verify {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 5%;
}

.form.verify #random {
  margin: 0 8px 0 12px;
  cursor: pointer;
}

.form.verify #random img {
  height: 48px;
  border: 1px solid #9E9E9F;
}

.form.verify .refresh {
  cursor: pointer;
  -webkit-transform: translate(0, 5px);
  -ms-transform: translate(0, 5px);
  transform: translate(0, 5px);
}

/* remind-modal */

.remind-content h2 {
  font-size: 20px;
  font-weight: bold;
  color: #c0272b;
  margin: 25px 0;
}

.remind-content p {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.remind-button img {
  display: block;
  margin: auto;
  width: 51%;
  padding: 20px 0 20px 0;
}

@media (max-width: 374px) {
  .exchange-content h2 {
    font-size: 20px;
  }

  .exchange-content .exchange-info p,
  .precautions {
    font-size: 14px;
  }

  .remind-content p {
    font-size: 20px;

  }
}
</style>